import { useEffect, useState } from 'react';
import { isMissingCloudFile, remoteCloudFileReference } from './cloudFileState';
import { resolveRemoteFile } from './remoteFiles';

export function useCloudFile(value: string) {
  const remote = Boolean(remoteCloudFileReference(value));
  const direct = !remote && !isMissingCloudFile(value) ? value : '';
  const [resolved, setResolved] = useState({ source: '', url: '', error: '' });
  useEffect(() => {
    if (!remote) return;
    const controller = new AbortController();
    void resolveRemoteFile(value, controller.signal)
      .then((url) => { if (!controller.signal.aborted) setResolved({ source: value, url, error: '' }); })
      .catch((error: unknown) => { if (!controller.signal.aborted) setResolved({ source: value, url: '', error: error instanceof Error ? error.message : 'โหลดไฟล์ไม่สำเร็จ' }); });
    return () => controller.abort();
  }, [value, remote]);
  const current = resolved.source === value ? resolved : { url: '', error: '' };
  return { url: direct || current.url, error: current.error, loading: remote && !current.url && !current.error };
}
